<!-- 左中 -->
<template>
    <div class="card_wrapper box box_v">
            <div class="title">志愿者服务队</div>
            <!--前三名-->
            <div class="box" style="padding:0 70px">
                <div class="top3 box_f1 box box_v"  v-if="topData.length>1">
                    <div class="bg_top2"></div>
                    <div class="title_top3">{{topData[1].userCount}}人</div>
                    <div class="subtitle_top3 box_f1">{{topData[1].volunteerOrgName}}</div>
                </div>
                <div class="top3 box_f1 box box_v" v-if="topData.length">
                    <div class="bg_top1"></div>
                    <div class="title_top3">{{topData[0].userCount}}人</div>
                    <div class="subtitle_top3 box_f1">{{topData[0].volunteerOrgName}}</div>
                </div>
                <div class="top3 box_f1 box box_v" v-if="topData.length>2">
                    <div class="bg_top3"></div>
                    <div class="title_top3">{{topData[2].userCount}}人</div>
                    <div class="subtitle_top3 box_f1">{{topData[2].volunteerOrgName}}</div>
                </div>
            </div>
        </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            topData:[{
                handleCount:111,
                title:'1'
            },{
                handleCount:111,
                title:'1'
            },{
                handleCount:111,
                title:'1'
            }]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
       getData(){
           this.$get(this.urlobj.xf_volunteer).then(res=>{
               this.topData = res.rows
           })
       }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.card_wrapper{
     width: 100%;
    height:100%;
    background-image: url('../../../assets/images/monitorctxf/center.png');
    background-size: 100% 100%;
    .title{
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        margin-left: 40px;
        margin-top: 20px
    }

    .top3{
        align-items: center;
        .bg_top1{
            width:75px;
            height:65px;
            background:url('../../../assets/images/monitorctxf/1.png');
            background-size: 100%;
        }
        .bg_top2{
            margin-top:20px;
            width:75px;
            height:65px;
            background:url('../../../assets/images/monitorctxf/2.png');
            background-size: 100%;
        
        }
        .bg_top3{
            margin-top:20px;
            width:75px;
            height:65px;
            background:url('../../../assets/images/monitorctxf/3.png');
            background-size: 100%;
        }
        .title_top3{
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            color: #FFFFFF;
            background: linear-gradient(0deg, #00F6FF 0%, #00FF90 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        .subtitle_top3{
            text-align: center;
            font-size: 14px;
            color: #FFF;
            line-height: 16px
        }
    }
}


</style>